import MarkdownIt from 'markdown-it'
import * as mdTable from 'markdown-it-multimd-table'
import ReactHtmlParser from 'react-html-parser'

export function convertMarkdown(markdown) {
  const md = new MarkdownIt('default', {
    html: true,
    linkify: true,
    typographer: true,
    rowspan: true,
    headerless: true,
  })

  const markdownTree = md.use(mdTable)

  const htmlTree = markdownTree.render(markdown)

  return ReactHtmlParser(htmlTree)
}
